import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './registerServiceWorker';
import { BrowserRouter } from 'react-router-dom';

import { AuthProvider } from './Context/AuthContext';

ReactDOM.render(
  <BrowserRouter>
    <AuthProvider>
        <App />
    </AuthProvider>
  </BrowserRouter>,
  document.getElementById('root'));

serviceWorker.unregister();

